export const MY_LOANS = '/my/loans';
export const MY_LOAN = (id) => `/my/${id}/loan`;
// TODO: intellectual можно вынести в отдельный файл
export const INTELLECTUAL_PROPERTY_MY = 'intellectual-property/my';
export const INTELLECTUAL_PROPERTY_GET = (id) => `/intellectual-property/get/${id}`;
export const INTELLECTUAL_PROPERTY_STORE = '/intellectual-property/store';
export const INTELLECTUAL_PROPERTY_UPDATE = '/intellectual-property/update';
export const INTELLECTUAL_PROPERTY_DELETE = (id) => `/intellectual-property/delete/${id}`;
export const ASSURANCE_SMS_SEND_BATCH = '/intellectual-property/assurance/sms-send/batch';
export const ASSURANCE_SMS_VERIFY_BATCH = '/intellectual-property/assurance/sms-verify/batch';
export const ASSURANCE_GET_PRE_FILE = (id) => `/intellectual-property/assurance/get-pre-file/${id}`;
export const BANK_ACCOUNTS_LIST = (accountId) => `bank-accounts/${accountId}/list`;
export const BANK_ACCOUNT = 'bank-account';
export const TICKET_CREATE = '/ticket/create';
export const FORM_DATA_GET = (key) => `/form-data/get/${key}`;
export const FORM_DATA_UPDATE = (key) => `/form-data/update/${key}`;
export const SETTINGS = 'settings';
export const REGISTER = '/register/primary';
export const INVEST_PRODUCT_LIST = 'invest-product-list';
export const PRE_AGREEMENT_OKUP = '/pre-agreement-okup';
export const PRE_AGREEMENT_BKI = '/pre-agreement-bki';
